var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',_vm._g(_vm._b({staticClass:"modal-wrapper",class:( _obj = {}, _obj[_vm.$attrs.name] = true, _obj ),attrs:{"scrollable":true}},'modal',_vm.$attrs,false),_vm.$listeners),[_vm._t("before-content"),_c('div',{staticClass:"modal-wrapper__content"},[_vm._t("content")],2),_vm._t("after-content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }